module.exports = __webpack_public_path__ + "img/icon-close.33e17217.svg";